import React, { useRef } from "react";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";

import BillingInfoPresenter from "presenters/BillingInfoPresenter";
import PaymentMethods from "components/PaymentMethods";

import Title from "../Title";

import useStyles from "./useStyles";

const CurrentBillingInfo = ({ billingInfo }) => {
  const classes = useStyles();
  const formRef = useRef();

  return (
    <>
      <Title>Card on File</Title>
      <div className={classes.root}>
        <form ref={formRef}>
          <div className={classes.grid}>
            <div className={classes.nameGrid}>
              <TextField type="text" id="firstName" value={BillingInfoPresenter.firstName(billingInfo)} disabled />
              <TextField type="text" id="lastName" value={BillingInfoPresenter.lastName(billingInfo)} disabled />
            </div>
            <div className={classes.cardGrid}>
              <TextField
                type="text"
                id="lastFour"
                value={`**** **** **** ${BillingInfoPresenter.lastFour(billingInfo)}`}
                disabled
              />
              <PaymentMethods type={BillingInfoPresenter.cardType(billingInfo)} />
            </div>
            <div className={classes.expireGrid}>
              <span className={classes.expires}>Card expires:</span>
              <TextField type="text" id="month" value={BillingInfoPresenter.month(billingInfo)} disabled />
              <TextField
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
                id="year"
                value={BillingInfoPresenter.year(billingInfo)}
                disabled
              />
              <TextField type="text" id="postalCode" value={BillingInfoPresenter.zip(billingInfo)} disabled />
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

CurrentBillingInfo.propTypes = {
  billingInfo: PropTypes.shape({}),
};

export default CurrentBillingInfo;
